class TMv_DateCountdown  {
	element;
	end_time;
	end_time_milli;
	day_number;
	hour_number;
	minute_number;
	second_number;

	constructor(element, params) {
		this.element = element;
		// Save dates to avoid calls in loop
		this.end_time = params.end_time.replace(' ', 'T');
		this.end_time_milli = Date.parse(params.end_time);
		this.day_number = this.element.querySelector('#day_number');
		this.hour_number = this.element.querySelector('#hour_number');
		this.minute_number = this.element.querySelector('#minute_number');
		this.second_number = this.element.querySelector('#second_number');

		this.initializeClock();

	}

	/**
	 * Initializes the clock with a loop that runs every second
	 */
	initializeClock() {
		let time_interval = setInterval(() => {
			let time = this.getTimeRemaining();

			this.day_number.textContent = time.days;
			this.hour_number.textContent = time.hours;
			this.minute_number.textContent = time.minutes;
			this.second_number.textContent = time.seconds;

			if (time.total <= 0)
			{
				clearInterval(time_interval);
			}
		}, 1000); // every second
	}

	/**
	 * Returns an array with the values for the time remaining
	 *
	 * @return {{total: number, days: number, hours: number, minutes: number, seconds: number}}
	 */
	getTimeRemaining()
	{
		let time = this.end_time_milli - Date.now();
		let seconds = Math.floor( (time/1000) % 60 );
		let minutes = Math.floor( (time/1000/60) % 60 );
		let hours = Math.floor( (time/(1000*60*60)) % 24 );
		let days = Math.floor( time/(1000*60*60*24) /*% 7*/);
		/*var weeks = Math.floor( time/(1000*60*60*24*7) );*/
		return {
			'total': time,
			/*'weeks': weeks,*/
			'days': days,
			'hours': hours,
			'minutes': minutes,
			'seconds': seconds
		};
	}

}